export { NotificationCenterComponent } from './notification-center';
